var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    { deliverableDetail: _vm.$route.name == 'deliverableDetail' || _vm.$route.name == 'weixin' || _vm.$route.name == 'toQrcode' },
    { ultraSmallSize: !((_vm.$route.name == 'odzid' && !_vm.getQuery('dataType')) || _vm.$route.name == 'zkzkid' || _vm.$route.name == 'onqid' || _vm.$route.name == 'oamid') },
    { newYearTheme: _vm.$store.state.NewYearTheme }
  ],attrs:{"id":"app"},on:{"dragover":_vm.handleDragover,"click":_vm.popHide}},[_c('keep-alive',{attrs:{"exclude":"SlideshowAllShow,OutLink"}},[(_vm.allShow)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d30e41","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 